// =============================================================================
// features/crm/components/ActiveFilterChips.tsx — Etiquetas removíveis dos
// filtros ativos da lista do CRM (F58-S08). Cada etiqueta desliga o seu
// filtro; "Limpar filtros" desliga todos. Presentational puro.
// =============================================================================

import * as React from 'react';

import type { ActiveFilterChip, FilterChipKey } from '../listFilters';

interface ActiveFilterChipsProps {
  chips: ActiveFilterChip[];
  onRemove: (key: FilterChipKey) => void;
  onClear: () => void;
}

export function ActiveFilterChips({
  chips,
  onRemove,
  onClear,
}: ActiveFilterChipsProps): React.JSX.Element | null {
  if (chips.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filtros aplicados">
      {chips.map((chip) => (
        <span
          key={chip.key}
          className="inline-flex items-center gap-1 pl-3 pr-1 py-0.5 rounded-pill bg-azul/10 border border-azul/30 text-azul font-sans text-xs font-semibold"
        >
          <span className="max-w-[240px] truncate">{chip.label}</span>
          <button
            type="button"
            onClick={() => onRemove(chip.key)}
            aria-label={`Remover filtro: ${chip.label}`}
            className="inline-flex items-center justify-center w-6 h-6 rounded-pill transition-colors duration-fast hover:bg-azul/15 active:bg-azul/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-azul/30"
          >
            <svg
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              className="w-3 h-3"
              aria-hidden="true"
            >
              <path d="M4 4l8 8M12 4l-8 8" strokeLinecap="round" />
            </svg>
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onClear}
        className="px-2 py-1 rounded-xs font-sans text-xs font-semibold text-ink-3 transition-colors duration-fast hover:text-ink hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-azul/20"
      >
        Limpar filtros
      </button>
    </div>
  );
}
